import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Base query setup
const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('authtoken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

// Base query with re-authentication handling
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    // Handle 401 error (unauthorized)
    if (result.error && result.error.status === 401) {
        localStorage.removeItem('authtoken');
        // You can trigger a logout action or redirect user here if needed
    }

    return result;
};

// Create the API service
export const MealsApi = createApi({
    reducerPath: 'MealsApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        postMealsQuestion: builder.mutation({
            query: (data) => ({
                url: `/meals/create-question/`,
                method: 'POST',
                body: data,
            }),
        }),
        GetQuestionList: builder.query({
            query: (param) => ({
                url: `/meals/get-question/`,
                method: 'Get',
                params: param
            })
        }),
        deleteQuestion: builder.mutation({
            query: (id) => ({
                url: `/meals/delete-question/${id}/`,
                method: 'DELETE'
            })
        }),
        updateQuestion: builder.mutation({
            query: ({ id, question_text }) => ({
                url: `/meals/edit-question/${id}/`,
                method: 'PUT',
                body: { question_text }  // Send the updated question text in the request body
            })
        }),

        GetMealslist: builder.query({
            query: (param) => ({
                url: `/meals/get-domainuseranswer/`,
                method: 'Get',
                
            })
        }),
        getmeals:builder.query({
            query:(param)=> ({
                url:`/meals/get-meal/`,
                method:'GET',
                params:param

            })
        }),
        GetMealschoice: builder.query({
            query: (param) => ({
                url: `/meals/meal-choices/`,
                method: 'GET',
                
            })
        }),
        postUserMeal : builder.mutation({
            
            query: (data) => ({
                url: `/meals/create-usermeal/`,
                method: 'POST',
                body: data,
            }),
        }),
        getAllUserMeal : builder.query({
            
            query: (data) => ({
                url: `/meals/get-allusermeal/`,
                method: 'GET',
            }),
        }),
        deleteAllUserMeal: builder.mutation({
            query: (id) => ({
                url: `/meals/delete-allusermeal/${id}/`,
                method: 'DELETE'
            })
        }),
        
        updateAssignedMeal: builder.mutation({
            query: (data) => ({
                url: `/meals/edit-allusermeal/`,
                method: 'PUT',
                body: data 
            })
        }),
        GetFoodItemList: builder.query({
            query: (param) => ({
                url: `/meals/get-meal/`,
                method: 'Get',
                params: param
            })
        }),
        GetAllFoodItemList: builder.query({
            query: (param) => ({
                url: `/meals/get-meals/`,
                method: 'Get',
                params: param
            })
        }),
        postFoodItem : builder.mutation({
            query: (data) => ({
                url: `/meals/create-meal/`,
                method: 'POST',
                body: data,
            }),
        }),
        updateFoodItem: builder.mutation({
            query: ({ id, data }) => ({
                url: `/meals/edit-meal/${id}/`,
                method: 'PUT',
                body:data
             
            })
        }),
        deleteFoodItem: builder.mutation({
            query: (id) => ({
                url: `/meals/delete-meal/${id}/`,
                method: 'DELETE'
            })
        }),
        postMealsAnswer: builder.mutation({
            query: (data) => ({
                url: `/meals/create-answer/`,
                method: 'POST',
                body: data,
            }),
            transformResponse: (response, meta) => ({
              data: response,
              status: meta?.response?.status,
            }),
        }),
    }), 
});

// Export hooks generated by RTK Query for the mutation
export const {useGetAllFoodItemListQuery,usePostMealsAnswerMutation,useDeleteFoodItemMutation,useUpdateFoodItemMutation,usePostFoodItemMutation,useGetFoodItemListQuery, usePostMealsQuestionMutation, useGetQuestionListQuery, useDeleteQuestionMutation, useUpdateQuestionMutation, useGetmealsQuery,useGetMealslistQuery,useGetMealschoiceQuery,usePostUserMealMutation,useGetAllUserMealQuery,useDeleteAllUserMealMutation,useUpdateAssignedMealMutation} = MealsApi;
